/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  FormControl,
  InputLabel,
  FormHelperText
} from '@material-ui/core'
import { useFormik } from 'formik'
import { UPTCPFormValidation } from '../../../../../utils/validationSchema'
import { FormLoader } from '../../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import { Typography } from '../../../../Dashboard/Wrappers/Wrappers'
import { useStyles } from './Styles'
import Configuration from '../../../../../Services/Api/Configuration'

const UPTCPForm = ({ onSubmit, results, resetResults }) => {
  const classes = useStyles()
  const intl = useIntl()
  const formActions = useFormik({
    initialValues: {
      file: ''
    },
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    validationSchema: UPTCPFormValidation,
    onSubmit: ((values, actions) => {
      onSubmit(values, actions)
    })
  })
  React.useEffect(() => {
      return () => {
        !!resetResults && resetResults()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
  const handleFileChange = (event, fieldName) => {
    event.preventDefault()
    let files = event.currentTarget.files
    if (files && files.length > 0) {
      !!resetResults && resetResults()
      if (!!formActions.errors[fieldName]) {
        formActions.setFieldError(fieldName, null)
      }
      let file = files[0]
      if (['text/csv'].includes(file.type)) {
        if (file.size <= Configuration.UPLOAD_FILE_SIZE) {
          formActions.setFieldValue(fieldName, file)
          setFilesName(event.target.value.replace(/.*(\/|\\)/, ''))
        } else {
          formActions.setFieldTouched(fieldName, true, true)
          setTimeout(() => formActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.largeFile' })), 50)
        }
      } else {
        formActions.setFieldTouched(fieldName, true, true)
        setTimeout(() => formActions.setFieldError(fieldName, intl.formatMessage({ id: 'validationSchema.unSupported' })), 50)

      }
    }
  }
  const [filesName, setFilesName] = React.useState(intl.formatMessage({ id: 'Fields.placeholder.UPTCPFile' }))

  return (
    <div className={classes.root}>
      <Accordion expanded={true}>
        <AccordionSummary
          expandIcon={<></>}
          aria-controls="panel1c-content"
          id="panel1c-header"
        >
          <div className={classes.uptcpHeader}>
            <Typography variant="h6">
              <FormattedMessage id='Fields.placeholder.UPTCPFile'/>
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          <form onSubmit={formActions.handleSubmit} noValidate autoComplete="off"
                className={classes.formWrapper}>

            {!!Object.keys(results || {}).length &&
            <>
              <Typography className={classes.hintWrapper + ' ' + classes.BasicInfoRow} variant={'h5'}>
                <FormattedMessage id='UPTCPFormImportProcess'
                                  values={{
                                    count: results?.total_number_of_rows,
                                    strong: chunks => <strong>{chunks}</strong>
                                  }}/>
              </Typography>

              {!!results?.success &&
              <Alert severity="success" variant="outlined"
                     className={classes.alertSpacing + ' ' + classes.BasicInfoRow}>
                <FormattedMessage id='UPTCPForm.success.title' values={{
                  count: results?.success,
                  strong: chunks => <strong>{chunks}</strong>
                }}/>
              </Alert>}

              {!!results?.skipped_rows &&
              <Alert severity="error" variant="outlined" className={classes.alertSpacing + ' ' + classes.BasicInfoRow}>
                <AlertTitle><FormattedMessage id='UPTCPForm.error.title' values={{
                  count: results?.skipped_rows,
                  strong: chunks => <strong>{chunks}</strong>
                }}/></AlertTitle>
                <FormattedMessage id='UPTCPForm.error.hint'/>
              </Alert>}
            </>}


            <div className={classes.BasicInfoRow}>
              <InputLabel htmlFor="file"><FormattedMessage id='Fields.Labels.UPTCPFile'/></InputLabel>
              <FormControl variant="outlined" margin="dense">
                <div className={classes.fileUploadWrapper} data-text={filesName}>
                  <input
                    accept="text/csv"
                    className={classes.fileUpload}
                    id="file"
                    name="file"
                    type="file"
                    onChange={(event) => handleFileChange(event, 'file')}
                  />
                </div>
                {formActions.errors.file && formActions.touched.file && (
                  <FormHelperText error={true}>{formActions.errors.file}</FormHelperText>
                )}
              </FormControl>
            </div>

            <button type="submit" disabled={formActions.isSubmitting || !formActions.isValid}
                    className={classes.AddAdminSubmit}>
              <FormattedMessage id='UPTCPForm.button.submit'/>
            </button>
            {formActions.isSubmitting && <FormLoader loading={true}/>}
          </form>
        </AccordionDetails>
        <Divider/>
      </Accordion>
    </div>
  )
}

export default UPTCPForm
